import React from "react";
import { FormControl, FormGroup, FormLabel } from "react-bootstrap";
import { InputBox } from "../../components";
import { ApiHelper, PaymentInterface } from "../../helpers";

interface Props {
  payment: PaymentInterface,
  onClose: () => void
}

export const EditPayment: React.FC<Props> = props => {

  const [payment, setPayment] = React.useState<PaymentInterface>(null);


  const init = () => {
    setPayment(props.payment);
  }

  React.useEffect(init, [props.payment])

  const handleSave = () => {
    ApiHelper.post("/payments", [payment]).then(() => { props.onClose() });
  }

  const updateValue = (id: string, val: string) => {
    let p: PaymentInterface = { ...payment };
    switch (id) {
      case "method": p.method = val; break;
      case "amount":
        p.amount = parseFloat(val.replace("$", "").replace(",", ""));
        p.unusedAmount = p.amount;
        break;
      case "description": p.description = val; break;
      case "details": p.details = val; break;
    }
    setPayment(p);
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    updateValue(e.currentTarget.id, e.currentTarget.value)
  }

  const formatter = Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });
  return (
    <>
      <InputBox headerText="Edit Payment" headerIcon="fa fa-money" saveFunction={handleSave} cancelFunction={props.onClose} >
        <FormGroup>
          <FormLabel>Type</FormLabel>
          <FormControl as="select" id="method" value={payment?.method} onChange={handleChange}>
            <option value="card">Credit Card</option>
            <option value="waived">Waived Charge</option>
            <option value="check">Check or PO</option>
          </FormControl>
        </FormGroup>
        <FormGroup>
          <FormLabel>Amount</FormLabel>
          <FormControl id="amount" value={formatter.format(payment?.amount)} onChange={handleChange} />
        </FormGroup>
        <FormGroup>
          <FormLabel>Public Description</FormLabel>
          <FormControl id="description" value={payment?.description} onChange={handleChange} placeholder="Check #103" />
        </FormGroup>
        <FormGroup>
          <FormLabel>Private Details</FormLabel>
          <FormControl id="details" value={payment?.details} onChange={handleChange} placeholder="Gave free month due to outage" />
        </FormGroup>
      </InputBox>
    </>
  );
};